
<div class="d-flex justify-content-center loader flex-column align-items-center" *ngIf="saving">
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>
 
<form class="user" [formGroup]="consentForm" (ngSubmit)="savePatientConsent()">
    <mat-card class="m-3 bg-primary-light">
      <mat-card-header>
        <mat-card-title class="mt-3"> Please note</mat-card-title>
        <mat-card-subtitle
          >Cancelation</mat-card-subtitle
        >
      </mat-card-header>
      <mat-card-content class="m-3">
        <div class="row">
          <div class="col-md-8">
            {{cancelationNote}}
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-between">
                <span>Initial Consultation</span>	
                <span>R0.00</span>
            </div>
            <div class="d-flex justify-content-between">
                <span>Follow up treatment</span>	
                <span>R0.00</span>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card #TreatmentConsent class="m-3">
      <mat-card-header>
        <mat-card-title class="mt-3">Treatment</mat-card-title>
        <mat-card-subtitle
          >Informed Consent</mat-card-subtitle
        >
      </mat-card-header>
      <mat-card-content class="m-3">
        <div class="row">
          <div class="col-md-12">
            <p *ngFor="let p of treatmentConsent; index as i; first as isFirst">
              <span *ngIf="isFirst">I, <b><u>{{ patient.Name }} {{ patient.Surname }}</u>, </b></span>{{p}}
            </p>
          </div>
          <div class="col-md-12 d-flex flex-column align-items-center">
            <h2 id="Consent">Do you consent to Treatment?</h2>
            <mat-radio-group
              class="bigRadio"
              aria-labelledby="Consent"
              formControlName="InformedTreatmentConsent">
              <mat-radio-button class="example-radio-button m-3" [value]="true">
                Yes
              </mat-radio-button>
              <mat-radio-button class="example-radio-button m-3" [value]="false">
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="consentForm.controls.InformedTreatmentConsent.errors || !patient.InformedTreatmentConsent && !consentForm.controls['InformedTreatmentConsent'].value">In order for you to be treatment we need your consent.</mat-error>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="m-3">
      <mat-card-header>
        <mat-card-title class="mt-3"
          >Financial Responsibility of My Account</mat-card-title
        >
        <mat-card-subtitle>Informed Consent</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content class="m-3">

        <div class="row">
          <div class="col-md-12">
            <p *ngFor="let p of financialConsent; index as i; first as isFirst">
              <span *ngIf="isFirst">I, <b><u>{{ patient.Name }} {{ patient.Surname }}</u>, </b></span>{{p}}
            </p>
          </div>
          <div class="col-md-12 d-flex flex-column align-items-center">
            <h2 class="text-center mb-2" id="FinancialConsent">Do you consent to the Financial responsibility involved?</h2>
            <mat-radio-group
              class="bigRadio"
              aria-labelledby="FinancialConsent"
              formControlName="InformedFinancialConsent">
              <mat-radio-button class="example-radio-button m-3" [value]="true">
                Yes
              </mat-radio-button>
              <mat-radio-button class="example-radio-button m-3" [value]="false">
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="consentForm.controls.InformedFinancialConsent.errors || !patient.InformedFinancialConsent && !consentForm.controls['InformedFinancialConsent'].value">In order for you to be treatment we need your consent.</mat-error>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="text-center">
      <mat-card-content class="m-3">
        <div class="row">
          <div class="col-md-8 d-flex flex-column justify-content-center">
            <h2>Patients Signature (Parent/Guardian of patient should the patient be
              younger than 18)</h2>
          </div>
          <div class="col-md-4 d-flex flex-column align-items-center">
            <img #signatureElement />
            <button mat-raised-button color="accent" type="button" (click)="openDialog()">
              {{!consentForm.dirty ? "ReSign" : "Sign"}}
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <p *ngIf="consentForm.invalid" class="text-error">Please ensure that you read and consent to the above </p>
    <mat-toolbar class="d-flex justify-content-between">
      <button type="button" mat-button (click)="back()">
        Back
      </button>
        <div class="d-flex">
        <button *ngIf="signed" mat-button type="button" (click)="generatePDF('view')"><i class="fa fa-download fa-2x" aria-hidden="true"></i>&nbsp;Preview PDF</button>
        <button mat-raised-button type="submit" color="primary">
          {{ saving ? 'Saving' : 'Save Consent' }}
        </button>
      </div>
    </mat-toolbar>
</form>
